import React, { useEffect, useState } from 'react';
import { func } from 'prop-types';
import { includes } from 'lodash';
import LoginForm from '../src/components/adfs/LoginForm';
import adfsAuth from '../src/utils/adfsAuth';
import { withNavigation } from '../src/hoc';
import { FlexContainer, Row, Text, CustomLogo, Icon, Column } from '../src/components/common';
import { MediaListener } from '../src/components/utils';

const Home = ({ navigate, ...props }) => {
    const { bo_sess: boSession, no_response: noResponse } = sessionStorage;
    const [showLoginError, setShowLoginError] = useState(false);
    useEffect(() => {
        adfsAuth.sessionIsValid((_, isValid) => {
            if (!isValid) {
                navigate('/');
            }
        });
        if (boSession === 'true' && noResponse === 'true') {
            setShowLoginError(true);
            adfsAuth.logout(data => console.log('logout', data))
            setTimeout(() => {
                sessionStorage.removeItem('bo_sess');
                sessionStorage.removeItem('no_response');
            }, 1000);
        }
    });
    return (
        <MediaListener values={['desktop', 'tablet', 'phone']}>
            {({ currentValue }) => (
                <FlexContainer direction='column' width='100vw' style={{ padding: `0 ${currentValue === 'phone' ? 5 : 30}%` }}>
                    <Row justify='center' mB={35} pB={38} mX={includes(['phone', 'tablet'], currentValue) ? 0 : 100} style={{ borderBottom: '1px solid #eaeaea' }} >
                        <CustomLogo style={{ height: 'auto', width: '225px' }} />
                    </Row>
                    <Row justify='center' mB={35}>
                        <Text text='Ingrese con su cuenta corporativa Cencosud' size={20} centered />
                    </Row>
                    <LoginForm />
                    { showLoginError && (
                        <Row backgroundColor='#f8f5ca' height='28px' align='center' justify='center' borderRadius='4px' mT={35} padding='5px'>
                            <Column noFlex>
                                <Icon name='caution' color='#d60000' size={16} right={10} />
                            </Column>
                            <Column noFlex>
                                <Text text='El usuario se encuentra deshabilitado o inactivo.' color='#d60000' />
                                <Text text='Intenta más tarde o comunicate con el administrador.' color='#d60000' />
                            </Column>
                        </Row>
                    ) }
                </FlexContainer>
            )}
        </MediaListener>
    );
};

Home.propTypes = {
    navigate: func
};

Home.defaultProps = {
    navigate: () => {}
};

export default withNavigation(Home);
